// extracted by mini-css-extract-plugin
export default {"wrapper":"_96jUChI","container":"eZ4XskC","title":"-xLTx8K"};